import { createContext, useCallback, useMemo, useState } from "react";

type ContextType = {
  activeStep: number;
  handleBack: () => void;
  handleNext: () => void;
};

export const StepperContext = createContext<ContextType>({
  activeStep: 0,
  handleBack: () => {},
  handleNext: () => {},
});

interface Props {
  children: React.ReactNode;
}

const StepperProvider = ({ children }: Props) => {
  const [activeStep, setActiveStep] = useState(0);

  const handleBack = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }, []);

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, []);

  const value = useMemo(
    () => ({
      activeStep,
      handleBack,
      handleNext,
    }),
    [activeStep, handleBack, handleNext]
  );

  return (
    <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
  );
};

export default StepperProvider;
